export const Status = {
  error: 'error',
  success: 'success',
  alert: 'alert',
  info: 'info',
  regular: 'regular',
  text: 'text'
}
